import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1),
    },
    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    title: {
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 650,
    },
    filterContainer: {
        marginBottom: theme.spacing(3),
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        width: '300px',
    }
}));

export default useStyles;